import api from 'Application/api/api';

const getGeneralTemplateFiles = (templateId, cancelToken = null) =>
    api.get(`project-manager/templates/${templateId}/files`, {
        cancelToken,
    });

export default getGeneralTemplateFiles;
